import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import appcolors from "../../constants/Colors";

function LanguageMenu() {
  const [defaultLang, setDefaultLang] = useState("English(UK)");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (val) => {
    setDefaultLang(val);
    setAnchorEl(null);
  };

  return (
    <Stack direction={"row"} alignItems={"center"}>
      <Typography variant="body2" color={appcolors.white}>
        {defaultLang}
      </Typography>
      <IconButton
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <ArrowDropDownIcon htmlColor="#ffffff" />
      </IconButton>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => handleClose("English(UK)")}>
          English(UK)
        </MenuItem>
        <MenuItem onClick={() => handleClose("اللغة العربية")}>
          اللغة العربية
        </MenuItem>
      </Menu>
    </Stack>
  );
}

export default LanguageMenu;
